<script>
  import TwoColumnPageLayout from '@/components/pages/layouts/TwoColumnPageLayout'
  import ServicePaymentContent from '@/components/content/ServicePaymentContent'
  import { mapGetters } from 'vuex'

  export default {
    components: { ServicePaymentContent, TwoColumnPageLayout },
    props: {},
    data: () => ({
      loadingAvailableServices: true,
      service: {
        id: null,
        icon_file: null,
        payments: null,
        service_url: null
      }
    }),
    computed: {
      ...mapGetters(['ui', 'login']),
      is_admin () {
        return Boolean(this.login.profile.is_admin)
      }
    },
    created () {
      this.getServiceDetail()
    },
    mounted () {},
    methods: {
      getServiceDetail () {
        this.loadingAvailableServices = true
        this.$http.get(`available-services/${this.serviceId}/`).then(
          (res) => {
            this.service = res.data
            this.loadingAvailableServices = false
          })
      }
    }
  }
</script>
